import { Pagination } from "@mui/material";

/**
 * Cursor-pagination footer for the audit list only.
 * The API returns nextToken rather than a total count, so the bar spans the
 * pages visited so far plus one more whenever another cursor is available.
 */
function AuditListPagination({
  page,
  rowsPerPage,
  rowCount,
  pageCount,
  knownRowCount,
  hasMorePages,
  onPageChange,
}) {
  const rangeStart = rowCount ? page * rowsPerPage + 1 : 0;
  const rangeEnd = rowCount ? page * rowsPerPage + rowCount : 0;
  const totalLabel = hasMorePages ? `${knownRowCount}+` : knownRowCount;

  return (
    <div className="pagination-wrap rda-pagination">
      <div className="pagination-wrap__meta">
        <p className="pagination-summary">
          Showing {rangeStart}-{rangeEnd} of {totalLabel}
        </p>
      </div>
      <Pagination
        page={page + 1}
        count={pageCount}
        color="primary"
        boundaryCount={1}
        siblingCount={1}
        onChange={(_event, newPage) => onPageChange(newPage - 1)}
      />
    </div>
  );
}

export default AuditListPagination;
